import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { FaqItemInterface } from 'src/shared/entities/faq/faq.schema'
import { generateHtmlAttrId } from 'src/shared/entities/utils/generate-base-entity'
import ServerPageInterface from 'src/shared/types/server-page-interface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'

export const addHtmlAttrIdToFaqItem = (
  entity: FaqItemInterface,
): FaqItemInterface => {
  if (!entity.htmlAttrId) {
    entity.htmlAttrId = generateHtmlAttrId(EntityTypeEnum.FaqItem)
  }

  return entity
}

export default (page: ServerPageInterface) =>
  migrateCommand({
    page,
    structureType: EntityTypeEnum.FaqItem,
    migrateFunction: addHtmlAttrIdToFaqItem,
  })
